import { DEFAULT_FORM_1099_REVIEW_FILTERS } from "@common/helpers/form1099-review-filters";
import { CounterpartyDirectoryColumn } from "@common/types/views/counterpartyDirectoryView";
import { ViewDensity, ViewType } from "@common/types/views/views";
import { counterpartyDirectoryCloseTemplateViewConfigSchema } from "@common/schemas/close-template-task-view-config.schema";

export const FORM_1099_ELIGIBLE_1099_REVIEW_COLUMN_OPTIONS = {
    customVariants: { variant: "review" },
    minSize: 140,
    maxSize: 180,
} as const;

function form1099TaskColumns() {
    return [
        {
            id: CounterpartyDirectoryColumn.NAME,
            options: { pin: "left" as const },
        },
        { id: CounterpartyDirectoryColumn.ACCOUNTS },
        { id: CounterpartyDirectoryColumn.JOURNAL_ENTRIES },
        { id: CounterpartyDirectoryColumn.AMOUNT },
        {
            id: CounterpartyDirectoryColumn.ELIGIBLE_1099,
            options: { ...FORM_1099_ELIGIBLE_1099_REVIEW_COLUMN_OPTIONS },
        },
    ];
}

export function createForm1099ViewConfig() {
    return counterpartyDirectoryCloseTemplateViewConfigSchema.parse({
        type: ViewType.COUNTERPARTY_DIRECTORY,
        columns: form1099TaskColumns(),
        filters: { ...DEFAULT_FORM_1099_REVIEW_FILTERS },
        options: {
            selection: true,
            bulkActions: true,
            density: ViewDensity.MD,
        },
    });
}
